import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="py-16 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20lifestyle%20scene%20with%20sneakers%20accessories%20and%20clothing%20on%20a%20clean%20cream%20surface%2C%20soft%20warm%20natural%20lighting%2C%20editorial%20photography%2C%20calm%20and%20inviting%20atmosphere%2C%20neutral%20earth%20tones%2C%20modern%20boutique%20display%2C%20elegant%20composition&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet CTA"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-900/60 to-primary-950/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
            Gotowy, aby odkryć najlepsze produkty?
          </h2>
          <p className="text-sm md:text-base text-background-200 mb-8 max-w-lg mx-auto">
            Przejdź do Kakobuy Spreadsheet i zacznij znajdować niesamowite okazje już teraz. Darmowy dostęp, zero ukrytych opłat.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold text-primary-700 bg-background-50 hover:bg-background-100 rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-file-list-3-line text-base"></i>
              Kakobuy Spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-lg transition-all whitespace-nowrap"
            >
              <i className="ri-shopping-cart-line text-base"></i>
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}